/**
 * Obfuscation, NOT encryption.
 *
 * This used to be crypto-js AES with a key hardcoded in the client bundle,
 * which anyone could read from devtools — so it never protected anything.
 * crypto-js is also unmaintained. Since real encryption is impossible here
 * (the key would have to ship to the browser either way), what is left is
 * plain base64: it keeps localStorage from being casually readable and
 * hand-editable, and nothing more. Do not treat anything stored through it
 * as confidential.
 */

const toBase64 = (value: string): string => {
  const bytes = new TextEncoder().encode(value);
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary);
};

const fromBase64 = (value: string): string => {
  const binary = atob(value);
  const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};

export const obfuscateData = <T>(data: T): string =>
  toBase64(JSON.stringify(data));

/** Throws on anything that is not our own output — callers must handle it. */
export const deobfuscateData = <T>(value: string): T =>
  JSON.parse(fromBase64(value)) as T;
